import { useEffect } from 'react';

var usePropDeprecationWarning = function usePropDeprecationWarning(_ref) {
  var _process3, _process3$env, _console2, _process4, _process4$env;

  var componentName = _ref.componentName,
      propName = _ref.propName,
      shouldWarn = _ref.shouldWarn,
      useInstead = _ref.useInstead,
      removalDate = _ref.removalDate,
      readMore = _ref.readMore;
  useEffect(function () {
    var _process, _process$env, _console, _process2, _process2$env;

    if ((_process = process) !== null && _process !== void 0 && (_process$env = _process.env) !== null && _process$env !== void 0 && _process$env.NODE_ENV && process.env.NODE_ENV !== 'production' && (_console = console) !== null && _console !== void 0 && _console.warn && shouldWarn && ((_process2 = process) === null || _process2 === void 0 ? void 0 : (_process2$env = _process2.env) === null || _process2$env === void 0 ? void 0 : _process2$env.DISABLE_DEPRECATION_WARNINGS) !== 'yes') {
      var deprecationWarning = "BUBBLE-UI DEPRECATION WARNING: '".concat(propName, "' prop of '").concat(componentName, "' is deprecated and will be removed");

      if (removalDate) {
        deprecationWarning += " in/by ".concat(removalDate);
      }

      deprecationWarning += ".";

      if (useInstead) {
        deprecationWarning += "\nUse '".concat(useInstead, "' prop instead.");
      }

      if (readMore) {
        deprecationWarning += "\nRead more on ".concat(readMore);
      }

      console.warn(deprecationWarning);
    }
  }, [(_process3 = process) === null || _process3 === void 0 ? void 0 : (_process3$env = _process3.env) === null || _process3$env === void 0 ? void 0 : _process3$env.NODE_ENV, (_console2 = console) === null || _console2 === void 0 ? void 0 : _console2.warn, shouldWarn, (_process4 = process) === null || _process4 === void 0 ? void 0 : (_process4$env = _process4.env) === null || _process4$env === void 0 ? void 0 : _process4$env.DISABLE_DEPRECATION_WARNINGS]);
};

export default usePropDeprecationWarning;
//# sourceMappingURL=index.js.map